import { BreakPointCondition, useBreakpointIf } from '@genial/components';
import { useNavigation } from '@react-navigation/native';
import { useCallback } from 'react';

import { OrderByModal } from '../../../../../../../../../../components/OrderByModal';
import { securitiesTransferOrderByAtom } from '../../../../../../../../../../store/customerDetail/SecuritiesTransfer/filters';

export const SecuritiesTransferOrderByModal = () => {
  const navigation = useNavigation();
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  const getSliderModalWidth = () => {
    if (isMobile) {
      return 1;
    }
    if (isTablet) {
      return 0.5;
    }
    return 0.3;
  };

  return (
    <OrderByModal
      onClose={goBack}
      sliderModalWidth={getSliderModalWidth()}
      orderByAtom={securitiesTransferOrderByAtom}
    />
  );
};
